import { string, shape, node } from 'prop-types';
import React from 'react';

import styles from './FeatureItem.module.scss';

const FeatureItem = ({ data }) => {
  const { title, icon, text } = data;
  return (
    <div className={styles.wrapper}>
      <div className={styles.icon}>{icon}</div>
      <div className={styles.title}>{title}</div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};

FeatureItem.propTypes = {
  data: shape({
    title: string,
    text: string,
    icon: node,
  }),
};

FeatureItem.defaultProps = {
  data: {
    title: '',
    text: '',
    icon: '',
  },
};

export default FeatureItem;
